export default __webpack_public_path__ + "static/media/Poppins-Bold.6ded092d.woff2";